import React from 'react';
import {useHistory, withRouter} from "react-router-dom";
import {connect} from 'react-redux';
import {logout} from '../../../state/actions/authActions';
import {Button, Card, CardActions, CardContent,} from '@material-ui/core';

function Logout(props) {
  const history = useHistory();
  return (
    <div style={{maxWidth: 250, margin: '0 auto', marginTop: 64}}>
      <Card style={{borderTop: '1px solid rgba(0,0,0,0.12)'}}>
          <CardContent>
            <h3>Logout</h3>
            <p>Do you want to log out?</p>
          </CardContent>
          <CardActions>
            <div style={{padding: 8, position: 'relative'}}>
              <Button onClick={ props.logout } variant='contained' color='primary'>Logout</Button>
              <Button variant='contained' color="secondary" onClick={() => history.goBack()} style={{marginLeft:16}}>Cancel</Button>
            </div>
          </CardActions>
      </Card>
    </div>
  )
}

const mapStateToProps = state => ({
  isLoggedIn: state.auth.uid
});

const mapDispatchToProps = {
  logout
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Logout));